import React from 'react';
import {
    FaRegBell,
    FaCheck,
    FaUtensils,
    FaBoxOpen,
    FaMotorcycle,
    FaHandHolding,
    FaConciergeBell,
    FaCheckDouble,
    FaTimesCircle,
    FaCircle,
} from 'react-icons/fa';

import { getStatusMeta } from './orderStatusFlow';
import '../css/OrderStatusPill.css';

const ICON_BY_NAME = {
    new: FaRegBell,
    accepted: FaCheck,
    cooking: FaUtensils,
    ready: FaBoxOpen,
    delivery: FaMotorcycle,
    pickup: FaHandHolding,
    served: FaConciergeBell,
    done: FaCheckDouble,
    cancelled: FaTimesCircle,
    unknown: FaCircle,
};

/**
 * Big, color + icon coded order status, readable at a glance for low-literacy staff.
 * When `onClick` is provided it renders as a button (used to open the status editor).
 */
const OrderStatusPill = ({ status, onClick, title }) => {
    const meta = getStatusMeta(status);
    const Icon = ICON_BY_NAME[meta.icon] || FaCircle;

    const style = {
        color: meta.color,
        backgroundColor: meta.bg,
        borderColor: meta.color,
    };

    const content = (
        <>
            <Icon className="order-status-pill__icon" aria-hidden="true" />
            <span className="order-status-pill__label">{meta.label}</span>
        </>
    );

    if (typeof onClick === 'function') {
        return (
            <button
                type="button"
                className="order-status-pill order-status-pill--clickable"
                style={style}
                onClick={onClick}
                title={title || `${meta.label} — tap to change`}
            >
                {content}
            </button>
        );
    }

    return (
        <span className="order-status-pill" style={style} title={title || meta.label}>
            {content}
        </span>
    );
};

export default OrderStatusPill;
